import { Controller } from "@hotwired/stimulus"

// Beeps when new tickets arrive on a kitchen / pickup screen.
export default class extends Controller {
  static targets = ["soundButton"]
  static values = { newCount: Number }

  connect() {
    this.soundOn = localStorage.getItem("kds-sound") !== "off"
    this.paintButton()
    const previous = Number(sessionStorage.getItem(this.storageKey) || 0)
    if (this.newCountValue > previous) this.beep()
    sessionStorage.setItem(this.storageKey, this.newCountValue)
  }

  get storageKey() {
    return `kds-count-${window.location.pathname}`
  }

  toggleSound() {
    this.soundOn = !this.soundOn
    localStorage.setItem("kds-sound", this.soundOn ? "on" : "off")
    this.paintButton()
    if (this.soundOn) this.beep()
  }

  fullscreen() {
    if (document.fullscreenElement) document.exitFullscreen()
    else document.documentElement.requestFullscreen?.()
  }

  paintButton() {
    if (!this.hasSoundButtonTarget) return
    this.soundButtonTarget.innerHTML = this.soundOn
      ? '<i class="ri-volume-up-line"></i>'
      : '<i class="ri-volume-mute-line"></i>'
  }

  beep() {
    if (!this.soundOn) return
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)()
      ;[880, 1175].forEach((freq, i) => {
        const osc = ctx.createOscillator()
        const gain = ctx.createGain()
        osc.frequency.value = freq
        gain.gain.value = 0.15
        osc.connect(gain).connect(ctx.destination)
        osc.start(ctx.currentTime + i * 0.18)
        osc.stop(ctx.currentTime + i * 0.18 + 0.15)
      })
    } catch (_) { /* audio blocked until first interaction */ }
  }
}
